<template>
  <section
    :id="anchorId"
    class="block"
    :class="classes"
    :data-vnode-id="vnodeId"
    @click="select"
    @mouseover="target"
    @contextmenu.prevent.stop="showContextMenu"
    @dblclick.stop.prevent="triggerOpenAssetManager"
  >
    <div
      v-show="showTextureBackground && isSectionUIEnabled"
      class="dashed-texture"
    />

    <cvt-sap-close-btn 
      v-if="isStandalonePopupActive" 
      :close-btn-position="sdaCloseButtonPosition"
    />

    <div
      v-show="showControlls && isSectionUIEnabled"
      class="block__target__indicator block__target__indicator--top"
    ></div>
    <div
      v-show="showControlls"
      class="block__target__indicator block__target__indicator--right"
    ></div>
    <div
      v-show="showControlls && isSectionUIEnabled"
      class="block__target__indicator block__target__indicator--bottom"
    ></div>
    <div
      v-show="showControlls"
      class="block__target__indicator block__target__indicator--left"
    ></div>

    <div :class="stylesheet.classes.bgImage"></div>
    <div :class="stylesheet.classes.bgColor"></div>

    <drag-items
      v-if="isGridBuilder && !isSectionUIEnabled"
      :vnode-id="vnodeId"
      :view-mode="viewMode"
    />

    <div 
      v-show="isSectionUIEnabled"
      class="section-controls-wrap"
    >
      <section-controls
        v-show="showControlls"
        :class="sectionControlsClasses"
        :vnode-id="vnodeId"
        @moveSectionUp="moveSectionUp"
        @moveSectionDown="moveSectionDown"
        @copySection="copySection"
        @swapSection="swapSection"
        @deleteSection="deleteSection"
      />
    </div>

    <div v-show="!isEmpty" :class="containerClasses">
      <template v-for="node in fbNode.children">
        <component
          :is="node.tag"
          :key="node.data.props.vnodeId"
          :fb-node="node"
          v-bind="node.data.props"
        ></component>
      </template>
    </div>

    <cvt-popover
      :ref="popoverRef"
      :mode="mode"
      placement="top"
      :target="`${anchorId}-add-core-element`"
      triggers="click"
    >
      <template #popper>
        <div class="d-flex">
          <cvt-button
            color="success"
            class="text-capitalize ml-1"
            :text="$t('add_section.cta')"
            @click.stop.prevent="openQuickLaunch"
          />
        </div>
      </template>
    </cvt-popover>
  </section>
</template>

<script>
import FirebaseNodeV3 from '../../base/FirebaseNode'
import GridContainer from './GridContainer.vue'
import Block from '../../../editor/nodes/Block.vue'

export default Block.extend({
  mixins: [FirebaseNodeV3],
  components: {
    'grid-container': GridContainer,
  },
  props: {
    fbNode: {
      type: Object,
       default: () => { 
        return { children: [] }; 
      },
    },
  },
})
</script>
